"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _colors = require("../../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCircle = (0, _styles.styled)(_material.Grid)(function () {
  return {
    height: '22px',
    width: '22px',
    borderRadius: '50%',
    margin: '0 7px'
  };
});
var StyledStepValue = (0, _styles.styled)(_material.Typography)(function () {
  return {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '13px'
  };
});

var Step = function Step(_ref) {
  var value = _ref.value,
      selected = _ref.selected;
  return /*#__PURE__*/_react.default.createElement(StyledCircle, {
    container: true,
    alignItems: "center",
    justifyContent: "center",
    "aria-label": "step",
    sx: {
      background: selected ? _colors.NAVY15 : _colors.BABY_BLUE3
    }
  }, /*#__PURE__*/_react.default.createElement(StyledStepValue, {
    sx: {
      color: selected ? 'white' : _colors.GREY8
    }
  }, value));
};

var _default = Step;
exports.default = _default;